import app from "./app";
import login from "./login";
export default {
  app,
  login,
};
